import { sendPost } from '../../http.js'
const commons = (url, params, fn) => {
  return sendPost(url, params)
    .then((res) => {
      fn(res)
      //console.log('成功')
    }).catch((err) => {
		throw Error(err)
      fn(err)
      //console.log('失败')
  })
}
const api = {
	'specialinfo': '/user/user/specialinfo',
	'createdspecial' : '/user/user/createdspecial/v2',
	'movespecial' : '/user/user/sortproduct',

	'upstatus': '/user/user/upstatus',
	'createH5linkAPI': '/user/user/create_h5pay_link' // 获取线下支付h5页面链接
}

export default {
	 specialinfo(params, fn) {
	 	commons(api.specialinfo, params, fn)
	 },
	createdspecial(params) {
		return sendPost(api.createdspecial, params)
	//  	commons(api.createdspecial, params, fn)
	 },
	movespecial(params) {
		return sendPost(api.movespecial, params)
	//  	commons(api.movespecial, params, fn)
	 },
	upstatus(params) {
		return sendPost(api.upstatus, params)
	 },
	createH5linkAPI(params) {
		return sendPost(api.createH5linkAPI, params)
 	}
}
